import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiUrls, apiHostUrl } from '../../shared/utils/globalConfig';
import { addHeaders } from '../../shared/utils/globalUtils';

export const cancelPendingOrderApi = createApi({
    reducerPath: 'cancelPendingOrder',
    baseQuery: fetchBaseQuery({
        baseUrl: apiHostUrl,
        prepareHeaders: (headers) => {
            return addHeaders(headers);
        }        
    }),
    endpoints: (builder) => ({
        getCancelPendingOrderByName: builder.query({
            query: (payload) => ({
                url: apiUrls?.cancelPendingOrderUrl,
                method: 'POST',
                body: payload
            })
        }),
    }),

})

export const { useLazyGetCancelPendingOrderByNameQuery } = cancelPendingOrderApi;